import {init} from "@prosay/i18n"
import * as Localization from "expo-localization"

// import * as Sentry from "@sentry/browser"
// Sentry.init({
//     debug: true,
//     dsn: "https://ae3e46df20e4428ca89298989f34477e@sentry.io/1461453",
// })

init({defaultLocale: "en", fallbacks: true, locale: Localization.locale})

export {App as default} from "./src"
